import React from 'react';
import styled from 'styled-components';
import cloudImg from '../assets/images/cloud.png';

const PageContainer = styled.div`
  padding-top: 80px;
  max-width: 900px;
  margin: 0 auto;
`;
const HeroImage = styled.div`
  width: 100%;
  height: 320px;
  background: url(${cloudImg}) center center/cover no-repeat;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.07);
`;
const Title = styled.h1`
  font-size: 2.3rem;
  font-weight: 700;
  margin: 2rem 0 2.5rem 0;
  color: #222;
  text-align: center;
`;
const Section = styled.section`
  margin-bottom: 2.5rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 2rem 2.5rem;
`;
const SectionTitle = styled.h2`
  font-size: 1.4rem;
  color: var(--primary);
  margin-bottom: 1rem;
  font-weight: 600;
`;
const Paragraph = styled.p`
  color: #333;
  line-height: 1.7;
  margin-bottom: 1.2rem;
`;
const ServiceList = styled.ul`
  margin-top: 0.5rem;
  margin-bottom: 1.2rem;
  list-style: disc inside;
  padding-left: 1.2rem;
`;
const ServiceItem = styled.li`
  color: #333;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;
const TagList = styled.ul`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding: 0;
  list-style: none;
`;
const Tag = styled.li`
  background: var(--primary);
  color: #fff;
  border-radius: 16px;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.4rem 1.1rem;
  margin-bottom: 0.5rem;
`;

const UseCaseCloudTransformation = () => (
  <PageContainer>
    <HeroImage />
    <Title>Cloud Transformation Strategy for a Global Manufacturing Enterprise</Title>
    <Section>
      <SectionTitle>The Situation</SectionTitle>
      <Paragraph>
        Large manufacturing companies often operate across multiple regions with fragmented infrastructure, legacy ERPs, siloed databases, and disconnected reporting systems. These issues lead to frequent production delays, lack of real-time inventory and asset tracking, and rising IT costs for maintaining outdated on-premise systems. Industry benchmarks show that enterprises like these may spend millions annually on inefficiencies, including downtime, reactive maintenance, and duplicated data efforts.
      </Paragraph>
    </Section>
    <Section>
      <SectionTitle>How Platform0 Would Help</SectionTitle>
      <Paragraph>
        Platform0 would architect a cloud-native, real-time backbone tailored to operations across regions:
      </Paragraph>
      <ServiceList>
        <ServiceItem>Hybrid or multi-cloud strategy to align with compliance and latency requirements</ServiceItem>
        <ServiceItem>Modern data pipelines connecting IoT sensors, MES, and supply chain systems</ServiceItem>
        <ServiceItem>Event-driven architecture for real-time inventory tracking and predictive maintenance</ServiceItem>
        <ServiceItem>Unified dashboard layer for global visibility across factories, suppliers, and warehouses</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>The Expected Outcomes</SectionTitle>
      <ServiceList>
        <ServiceItem>Reduced IT overhead by 30–50%</ServiceItem>
        <ServiceItem>Improved delivery SLAs through real-time visibility</ServiceItem>
        <ServiceItem>Lower production losses through predictive analytics</ServiceItem>
        <ServiceItem>More scalable infrastructure to support business growth</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>Relevant Platform0 Services</SectionTitle>
      <TagList>
        <Tag>Architecture as a Service</Tag>
        <Tag>Cloud Solutions</Tag>
        <Tag>Digital Transformation</Tag>
      </TagList>
    </Section>
  </PageContainer>
);

export default UseCaseCloudTransformation;
